import { config } from '@abyss/web/tools/config';

export const CteApiUrl = config('CTE_API_URL');
export const CTE_API_URL = config('CTE_API_URL');
